export interface NameSuggestionItem {
  text: string;
  isCollection: boolean;
  magicKey: string;
  formattedText?: string;
}

export interface NameSuggestionResponse {
  suggestions: NameSuggestionItem[];
}

export interface SpatialReference {
  latestWkid: number;
  wkid: number;
}

export interface NameServiceLocation {
  spatialReference: SpatialReference;
  x?: number;
  y?: number;
}

export interface NameSuggestionRequest {
  location: NameServiceLocation;
  text: string;
  maxSuggestions: number;
  f: string;
}
